import { useMemo } from 'react';

import SinkItems from '../SinkItems';

import { ApplianceModel, ApplianceSource } from '~/core/models';

interface BrowsedSinkItemsProps {
  sinks: ApplianceModel[];
  skeletonSinks?: ApplianceModel[];
  onSelectSink: (sink: ApplianceModel) => void;
  onAddSink: (sink: ApplianceModel) => void;
}

const filterSinksBySource = (
  sinks: ApplianceModel[],
  applianceSource: ApplianceSource
) => sinks.filter((sink) => sink.productSource === applianceSource);

const BrowsedSinkItems = ({
  sinks,
  skeletonSinks = [],
  onSelectSink,
  onAddSink,
}: BrowsedSinkItemsProps) => {
  const programSinks = useMemo(
    () => filterSinksBySource(sinks, ApplianceSource.PROGRAM),
    [sinks]
  );
  const inStoreSinks = useMemo(
    () => filterSinksBySource(sinks, ApplianceSource.IN_STORE),
    [sinks]
  );

  const programSkeletonSinks = useMemo(
    () => filterSinksBySource(skeletonSinks, ApplianceSource.PROGRAM),
    [skeletonSinks]
  );
  const inStoreSkeletonSinks = useMemo(
    () => filterSinksBySource(skeletonSinks, ApplianceSource.IN_STORE),
    [skeletonSinks]
  );

  return (
    <>
      <SinkItems
        sinks={programSinks}
        skeletonSinks={programSkeletonSinks}
        applianceSource={ApplianceSource.PROGRAM}
        onSelectSink={onSelectSink}
        onAddSink={onAddSink}
      />
      <SinkItems
        sinks={inStoreSinks}
        skeletonSinks={inStoreSkeletonSinks}
        applianceSource={ApplianceSource.IN_STORE}
        onSelectSink={onSelectSink}
        onAddSink={onAddSink}
      />
    </>
  );
};

export default BrowsedSinkItems;
